export const miotaToIota = (amount) => {
    return amount * 1000000;
}
